const maxRecentActivities = 10;

export { maxRecentActivities };